import React from 'react'
import Navbar from '../../components/navbar/Navbar'
import ProductOutInvoice from '../../components/invoices/ProductOutInvoice'

const ProductOutInvoicePage = () => {
    return (
        <>

            <section className="bajaj_main_block">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-lg-12 p-0">
                            <Navbar content="INVOICE" />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-12 p-0">
                            <ProductOutInvoice />
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default ProductOutInvoicePage